import { BallBg, Button, Col, Text } from 'components';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 1278px;
  position: relative;
  align-items: center;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const Wrapper = styled(Col)`
  margin-top: 34px;
  align-items: center;

  @media (max-width: 1024px) {
    margin-top: 7px;
  }
`;

const BannerText = styled(Text)`
  width: 100%;
  margin-left: 140px;

  @media (max-width: 1024px) {
    margin-left: 22px;
    font-size: 52px;
  }
`;
const PostsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 10px;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }
`;

const SocialMediaPost = styled.img`
  height: 580px;
  width: 397px;
  margin: 0 0 24px;

  @media (max-width: 1024px) {
    padding: 0 0 0 1px;
    height: 567px;
    width: 388px;
  }
`;

const SocialMedia = (props) => {
  const { t } = useTranslation();

  const data = []; //placeholder

  for (let i = 0; i < 6; i++) {
    data.push({ image: require('assets/images/instagram-post.png') });
  }

  return (
    <Wrapper>
      <BallBg />
      <ContentArea>
        <BannerText spacing="-3.5px" bold stencil size="72px">
          {t('website.stayVisible')}
        </BannerText>

        <PostsContainer>
          {data?.map((x, i) => (
            <SocialMediaPost key={i} src={x.image} />
          ))}
        </PostsContainer>

        <Button website wid="178px" marg="92px 0" text="Load More" onClick={() => {}} />
      </ContentArea>
    </Wrapper>
  );
};

export default SocialMedia;
